import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-mobile-page-header',
  templateUrl: './mobile-page-header.component.html',
  styleUrls: ['./mobile-page-header.component.scss'],
})
export class MobilePageHeaderComponent implements OnInit {
  @Input() showAfter: boolean = true;
  @Input() backButtonLink?: string;
  @Input() pageTitle: string = '';
  @Input() isHomePage: boolean = false;
  @Input() showBalance: boolean = true;
  @Input() showQr: boolean = true;
  @Input() showFooter: boolean = false;
  @Input() isImageBanner: boolean = false;
  @Input() imageBannerUrl: string = '';
  isCorporate: boolean;
  isJuniorBluebird: boolean;
  populations = Populations;

  screenType = ScreenType;
  memberCard$: Observable<MemberCard | undefined>;
  ecash$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  member$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;

  @ViewChild('nav', { static: false }) navRef!: ElementRef<HTMLDivElement>;
  atRightEnd = false;

  constructor(
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery,
    private router: Router,
    private populationQuery: PopulationQuery,
    private location: Location,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
    this.isJuniorBluebird = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);
  }

  //hide after for mobile nav
  ngAfterViewInit() {
    this.updateRightEnd();

    this.ngZone.runOutsideAngular(() => {
      const handler = () => this.ngZone.run(() => this.updateRightEnd());
      window.addEventListener('resize', handler);
    });
  }

  onNavScroll() {
    this.updateRightEnd();
  }

  private updateRightEnd() {
    const el = this.navRef?.nativeElement;
    if (!el) return;

    const { scrollLeft, clientWidth, scrollWidth, dir } = el;

    const isRtl = (dir || getComputedStyle(el).direction) === 'rtl';
    const current = isRtl ? Math.abs(scrollLeft) : scrollLeft;

    const epsilon = 1;
    this.atRightEnd = current + clientWidth >= scrollWidth - epsilon;
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
